import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ged-temp--sprite",
  "use": "ged-temp--sprite-usage",
  "viewBox": "0 0 96 59",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 59\" id=\"ged-temp--sprite\">\n  <text id=\"ged-temp--sprite_GED\" transform=\"translate(0 48)\" fill=\"#067fbf\" font-size=\"52\" font-family=\"FranklinGothic-Medium, Franklin Gothic\" font-weight=\"500\"><tspan x=\"0\" y=\"0\">GED</tspan></text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol